import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../../src/app/core/models/generic-models';
import { fromEmployeeWithdrawalsActions } from '../actions';

export const downloadPlaybackDocumentFeatureKey = 'downloadPlaybackDocument';

export interface DownloadPlaybackDocumentState {
  loadDownloadPlaybackDocumentRequest: string;
  loadDownloadPlaybackDocumentResponse: string;
  loadDownloadPlaybackDocumentFailure: IGenericError<ErrorResponse>;
}

export const initialState: DownloadPlaybackDocumentState = {
  loadDownloadPlaybackDocumentRequest: undefined,
  loadDownloadPlaybackDocumentResponse: undefined,
  loadDownloadPlaybackDocumentFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromEmployeeWithdrawalsActions.loadDownloadPlaybacks, (state, action) => ({
    ...state,
    loadDownloadPlaybackDocumentRequest: action.name
  })),
  on(fromEmployeeWithdrawalsActions.loadDownloadPlaybacksSuccess, (state, action) => ({
    ...state,
    loadDownloadPlaybackDocumentResponse: action.response
  })),
  on(fromEmployeeWithdrawalsActions.loadDownloadPlaybacksFailure, (state, action) => ({
    ...state,
    loadDownloadPlaybackDocumentFailure: action.error
  }))
);
